import React from 'react';
import ScenarioPanel from '../../ScenarioPanel/ScenarioPanel';
import SimulationApexChart from '../../Charts/SimulationApexChart';
import HelpTooltip from '../../HelpTooltip/HelpTooltip';
import './SimulationWindow.css';

const SimulationWindow = ({
  onRunScenario,
  loading,
  simpleForecastData,
  onChartContextChange,
  onScenarioContextChange
}) => {
  const resolvedGranularity = simpleForecastData?.metadata?.resolved_granularity || simpleForecastData?.metadata?.forecast_granularity || '';
  const summaryLabel = resolvedGranularity === 'monthly'
    ? 'Monthly Summary'
    : resolvedGranularity === 'weekly'
      ? 'Weekly Summary'
      : 'Daily Summary';

  return (
    <div className="simulation-window">
      <div className="window-header" style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', gap: '10px' }}>
        <h2 style={{ margin: 0 }}>Simulation Setup</h2>
        <HelpTooltip
          title="Scenario Generation"
          content="Test specific scenarios by applying growth or shrinkage constraints to the baseline forecast. View upper and lower confidence intervals to understand demand volatility."
        />
      </div>
      <ScenarioPanel
        onRunScenario={onRunScenario}
        loading={loading}
        onContextChange={onScenarioContextChange}
      />
      {simpleForecastData && (
        <section className="card">
          <h2 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            📈 Scenario Forecast Chart
            <HelpTooltip content="A visual representation of the forecasted demand under the simulated scenario parameters." />
            <span style={{
              fontSize: '0.72rem',
              padding: '2px 8px',
              borderRadius: '20px',
              background: 'rgba(37,99,235,0.10)',
              color: '#2563EB',
              border: '1px solid rgba(37,99,235,0.20)',
              fontWeight: 600,
            }}>
              {summaryLabel}
            </span>
          </h2>
          <SimulationApexChart data={simpleForecastData} onChartContextChange={onChartContextChange} />
        </section>
      )}
    </div>
  );
};

export default SimulationWindow;
